const isLowerEnvironment = ((host) =>
  /^(localhost:\d{4,5}|uce\.(dev|staging|uat).archer-group.com)$/.test(host))(window.location.host);

export { isLowerEnvironment };
